import * as React from 'react';

function SvgSuccess(props) {
    return (
        <svg width={16} height={16} fill="none" {...props}>
            <rect width={16} height={16} rx={8} fill="#353E50" />
            <path
                d="M12 5l-5.5 6L4 8.5"
                stroke="#4CAF50"
                strokeWidth={1.4}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default SvgSuccess;
